const enviroment = {
    // apiUrl: "http://localhost:5000",
    // apiUrl: "https://vonble-backend.onrender.com",
    apiUrl: "https://vonblebackend-production.up.railway.app",

};

export default enviroment;
